import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class ProgressBarHandler {

    public highlightSubject = new BehaviorSubject(false);

    public highlightNextStep(state: boolean) {
        this.highlightSubject.next(state);
    }

}
